"use client";

import React from "react";
import { cn } from "@/lib/utils";
import type { ToggleOption } from "./toggle-helpers";

interface FieldRowToggleProps {
  options: ToggleOption[];
  currentValue: string;
  onSelect: (newRawValue: string) => void;
}

export function FieldRowToggle({ options, currentValue, onSelect }: FieldRowToggleProps) {
  return (
    <div className="flex rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden shadow-sm">
      {options.map((opt, idx) => {
        const isActive = currentValue === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => onSelect(opt.value)}
            className={cn(
              "flex-1 px-3 py-2 text-sm font-medium transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary",
              idx > 0 && "border-l border-gray-200 dark:border-gray-700",
              isActive
                ? "bg-primary text-white"
                : "bg-white dark:bg-gray-900 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800"
            )}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
